export const SET_TV_SETTINGS = 'SET_TV_SETTINGS'



// WEBPACK FOOTER //
// ./src/types/tvSettings.js